import { LanguageDate } from "src/helpers/CheckLanguageDate";
import { useTranslation } from "react-i18next";
import { makeApiCall } from "src/api/apiRequests";
import { useEffect, useState } from "react";
import { PermissionCheck } from "src/helpers/PermissionCheck";
import * as ConfirmPopup from "../../../helpers/ConfirmPopup";

import API_HEADERS from "src/api/apiConfig";
import API_PATHS from "src/api/apiPaths";
import DatePicker from "react-datepicker";
import moment from "moment";
import SearchFilter from "src/helpers/SearchFilter";
import ListResponse from "src/helpers/ListResponse";
import FLASH_MESSAGES from "src/helpers/FlashMessages";
import Loading from "src/helpers/Loading";
import AddHoliday from "./AddHoliday";
import EditHoliday from "./EditHoliday";
import useSearchSubmit from "src/hooks/useSearchSubmit";
import CustomPagination from "src/helpers/CustomPaginate";

const HolidaysList = () => {

const { t } = useTranslation();
const {
  searched,
  searchInputs,
  searchBtnLoading,
  setSearchBtnLoading,
  handleSubmit,
  page,
  setPage,
} = useSearchSubmit();

  const [year, setYear] = useState<any>(null);
  const [holidaysList, setHolidaysList] = useState<any[]>([]);
  
  const [loading, setLoading] = useState(true);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [modalId, setModalId] = useState<number | null>(1);
  const [pagination, setPagination] = useState<any>([]);

  

  const getListOfHolidays = async (e?: any): Promise<void> => {
    const searchParams: any = searchInputs;
    let request: any = SearchFilter(
      searchParams,
      API_PATHS.holidaysList //+"?year=2024" ??
    );
    try {
      const response: any = await makeApiCall<ResponseType>(
        request,
        "GET",
        API_HEADERS.authenticated
      );
      setHolidaysList(response.holidays.data);
      setPagination(response.holidays);
      setSearchBtnLoading(false);
      setLoading(false);
    } catch (error: any) {
      FLASH_MESSAGES.errorMsg(error.response.data.error);
    }
  };

  useEffect(() => {
    getListOfHolidays();
  }, [searched, searchInputs]);

  const deleteHoliday = (holidayId: number, holidayTitle: string) => {
    ConfirmPopup.deletePopup(
      t("delete_holiday_title"),
      t("delete_holiday_type"),
      holidayTitle
    ).then(async (response) => {
      if (response.isConfirmed) {
        try {
          const response: any = await makeApiCall<ResponseType>(
            API_PATHS.deleteHoliday(holidayId),
            "DELETE",
            API_HEADERS.authenticated
          );
          FLASH_MESSAGES.successMsg(response.success);
          if (holidaysList.length === 1 && page > 1) {
            setPage(page - 1);
          } else {
            getListOfHolidays();
          }
        } catch (error: any) {
          if (error.response.data.error) {
            FLASH_MESSAGES.errorMsg(error.response.data.error);
          }
        }
      }
    });
  };
  return (
    <>
      <form
        onSubmit={(e) =>
          handleSubmit(e, {
            ...(year && { year: moment(year).format("yyyy") }),
          })
        }
        className="row"
      >
        <div className="form-block col-12 col-sm-6 col-md-3 col-xxl-2">
          <label>{t("holiday_year_label")}</label>
          <DatePicker
            selected={year}
            onChange={(e: any) => setYear(e)}
            showYearPicker
            dateFormat="yyyy"
            isClearable
            placeholderText={t("holiday_year_placeholder")}
            className="form-datepicker"
            yearItemNumber={12}
            autoComplete="off"
            popperClassName="navigations"
            locale={LanguageDate.datepicker}
            name="year"
          />
        </div>
        <div className="col-12 col-sm-6 col-md-3 col-xxl-2 mt-4">
          {searchBtnLoading ? (
            <button type="button" className="button-orange has-icon my-auto">
              <i className="icon spinner-icon" />
              {t("reports_transfer_searching_button")}
            </button>
          ) : (
            <button type="submit" className="button-orange has-icon my-auto">
              <i className="icon search-icon" />
              {t("reports_transfer_search_button")}
            </button>
          )}
        </div>
      </form>
      {PermissionCheck("holiday-store") ? (
        <div className="d-flex justify-content-end mb-5 ">
          <button
            className="button-blue has-icon"
            onClick={() => setShowAddModal(true)}
          >
            <i className="icon plus-icon" />
            {t("add_button_holiday")}
          </button>
          {showAddModal && (
            <AddHoliday
              showModal={showAddModal}
              setShowModal={(e) => setShowAddModal(e)}
              setModified={(e) => getListOfHolidays(e)}
            />
          )}
        </div>
      ) : (
        ""
      )}
      <div className="table-list mb-5">
        <table role="table" className="w-100">
          <thead>
            <tr role="row">
              <th
                style={{ width: "45%" }}
                role="columnheader"
                className="text-left"
              >
                <i className="icon  sidebar-holiday-icon " />
                {t("holiday_name")}
              </th>
              <th
                style={{ width: "35%" }}
                role="columnheader"
                className="text-left"
              >
                <i className="icon  calender-icon " />
                {t("holiday_date")}
              </th>
              <th
                style={{ width: "20%" }}
                role="columnheader"
                className="text-center"
              >
                <i className="icon actions-icon" />
                {t("staff_actions")}
              </th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td className="text-center" colSpan={2}>
                  <Loading />
                </td>
              </tr>
            ) : (
              holidaysList.map((holiday: any) => (
                <tr key={holiday.id}>
                  <td
                    role="cell"
                    className="text-left bold-text"
                    data-label={t("role_name")}
                  >
                    {holiday.description}
                  </td>
                  <td
                    role="cell"
                    className="text-left bold-text"
                    data-label={t("role_name")}
                  >
                    {moment(holiday.date).format("DD-MM-yyy")}
                  </td>

                  <td
                    role="cell"
                    className="text-center "
                    data-label={t("staff_actions")}
                  >
                    <div className="actions">
                      {PermissionCheck("holiday-update") ? (
                        <>
                          <button
                            className="button-unstyled"
                            onClick={() => {
                              setShowEditModal(true);
                              setModalId(holiday.id);
                            }}
                          >
                            <i className="icon edit-icon " />
                          </button>
                          {modalId === holiday.id && showEditModal && (
                            <EditHoliday
                              showModal={showEditModal}
                              setShowModal={(e) => {
                                setShowEditModal(e);
                                setModalId(null);
                              }}
                              setModified={(e) => getListOfHolidays(e)}
                              holidayId={holiday.id}
                            />
                          )}
                        </>
                      ) : (
                        ""
                      )}
                      {PermissionCheck("holiday-delete") ? (
                        <button
                          type="button"
                          key={holiday.id}
                          className="button-unstyled"
                          onClick={() =>
                            deleteHoliday(holiday.id, holiday.description)
                          }
                        >
                          <i className="icon delete-icon" />
                        </button>
                      ) : (
                        ""
                      )}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
        <ListResponse totalItems={holidaysList?.length} loading={loading} />
      </div>
      <CustomPagination data={pagination} setActivePage={(e) => setPage(e)} />
    </>
  );
};
export default HolidaysList;
